// Logique commune de notification flottante pour les formulaires de contact
// natifs Shopify utilises comme prise de contact "Etre informe du lancement"
// (configurateur + bloc email HP).
//
// 2026-08-09 (retour "ca actualise la page car ca lance /?contact_posted=
// true#..." — le probleme principal) : ABANDON de l'interception AJAX
// (fetch + preventDefault) tentee depuis le 2026-08-07. Cause racine
// identifiee en testant un vrai clic (pas un evenement synthetique) sur
// staging :
//   - {% form 'contact' %} est protege par la verification anti-spam
//     NATIVE de Shopify (l'URL /contact repond "400 Missing CAPTCHA token"
//     a tout fetch() direct, qui ne passe jamais par le script de
//     verification injecte par Shopify).
//   - Sur un vrai clic, Shopify gere lui-meme ce defi puis declenche SA
//     PROPRE soumission native reelle (form.submit() ou equivalent interne)
//     une fois valide — un appel qui ne passe PAS par l'evenement "submit"
//     que ce fichier ecoute, donc jamais annulable via preventDefault(),
//     quel que soit le nombre de listeners "submit" attaches ici ou en
//     filet de securite dans les sections.
//   - Resultat observe : notre fetch() (toujours en echec cote Shopify)
//     etait pris a tort pour un succes par looksLikeFailure() (qui ne
//     verifiait jamais res.ok/res.status), d'ou le toast + bouton
//     "Email enregistre" qui s'affichaient brievement — juste avant que la
//     vraie soumission native de Shopify recharge la page.
// Nouvelle approche, plus simple et fiable : on laisse la soumission
// native native suivre son cours (aucun preventDefault ici), et on affiche
// le toast flottant APRES le rechargement, en detectant
// "?contact_posted=true" + le #id du formulaire dans l'URL de retour
// Shopify. Fonctionne aussi si JS est desactive/echoue (juste sans toast).
//
// Peut etre inclus plusieurs fois sur la meme page (configurateur + bloc
// email peuvent cohabiter) : le if en tete evite toute redeclaration/double
// creation du toast si le fichier est charge 2 fois.
//
// API :
//   window.HexagonContactForm.init(form, options)
//     form                Le <form> Shopify ({% form 'contact' %}) a
//                         armer. Rien ne se passe si null/undefined.
//     options.successTitle / successText   Textes du toast si CE formulaire
//                         est celui detecte au retour de Shopify (voir
//                         checkPostRedirect ci-dessous).
//     options.beforeSubmit()  appele juste avant la soumission native (ex :
//                             remplir un champ cache avec un resume, cote
//                             configurateur). Un echec ici ne doit jamais
//                             bloquer l'envoi (voir try/catch appelant).
//   window.HexagonContactForm.showToast({ type: 'success'|'error', title, text })
//     Utilisable independamment si besoin ponctuel.
if (!window.HexagonContactForm) {
  (function () {
    var TOAST_VISIBLE_MS = 6000;

    var toastEl = null;
    var hideTimer = null;

    function ensureToast() {
      if (toastEl) return toastEl;
      toastEl = document.createElement('div');
      toastEl.className = 'form-toast';
      toastEl.setAttribute('data-form-toast', '');
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      toastEl.setAttribute('aria-atomic', 'true');
      toastEl.hidden = true;
      toastEl.innerHTML =
        '<p class="form-toast__title" data-form-toast-title></p>' +
        '<p class="form-toast__text" data-form-toast-text></p>' +
        '<button type="button" class="form-toast__close" data-form-toast-close aria-label="Fermer">×</button>';
      document.body.appendChild(toastEl);
      toastEl.querySelector('[data-form-toast-close]').addEventListener('click', hideToast);
      return toastEl;
    }

    function hideToast() {
      if (!toastEl) return;
      window.clearTimeout(hideTimer);
      toastEl.classList.remove('is-visible');
      window.setTimeout(function () {
        if (toastEl && !toastEl.classList.contains('is-visible')) toastEl.hidden = true;
      }, 220);
    }

    function showToast(opts) {
      opts = opts || {};
      var el = ensureToast();
      window.clearTimeout(hideTimer);
      el.classList.toggle('form-toast--error', opts.type === 'error');
      el.querySelector('[data-form-toast-title]').textContent = opts.title || '';
      el.querySelector('[data-form-toast-text]').textContent = opts.text || '';
      el.hidden = false;
      // Force le reflow pour que la transition rejoue meme si un toast
      // etait deja affiche au moment de l'appel.
      void el.offsetWidth;
      el.classList.add('is-visible');
      hideTimer = window.setTimeout(hideToast, TOAST_VISIBLE_MS);
    }

    // form.id -> { successTitle, successText } enregistres par chaque appel
    // a init(), pour que checkPostRedirect() sache quels textes utiliser
    // une fois revenu sur la page apres le vrai POST natif Shopify.
    var registry = {};

    function init(form, options) {
      if (!form || !form.id) return;
      options = options || {};
      registry[form.id] = {
        successTitle: options.successTitle,
        successText: options.successText
      };

      // Tracking GA4 (assets/hexagon-tracking.js) : memorise le formulaire soumis ; l'evenement
      // generate_lead n'est envoye qu'au RETOUR reussi de Shopify (checkPostRedirect), jamais ici.
      form.addEventListener('submit', function () {
        try {
          var cfg = (options.trackingConfig && options.trackingConfig()) || null;
          if (window.HexagonTracking) window.HexagonTracking.leadPending(form.id, cfg);
        } catch (trackErr) { /* le tracking ne doit jamais bloquer l'envoi */ }
      });

      if (typeof options.beforeSubmit !== 'function') return;
      form.addEventListener('submit', function () {
        // Aucun preventDefault ici : on laisse Shopify gerer sa propre
        // verification anti-spam puis la vraie soumission native. On se
        // contente d'enrichir le formulaire juste avant qu'il parte.
        try {
          options.beforeSubmit();
        } catch (err) {
          // Ne doit jamais empecher l'envoi (voir commentaire beforeSubmit
          // dans assets/configurateur.js).
        }
      });
    }

    // Shopify redirige vers l'URL d'origine du formulaire avec
    // "?contact_posted=true" apres un POST /contact reussi, en conservant
    // le #id du formulaire d'origine dans le fragment (ex :
    // "#HomeEmailInterestForm" ou "#ConfiguratorNotifyForm") — c'est ce qui
    // permet de savoir quel toast afficher, meme avec 2 formulaires "Etre
    // informe du lancement" sur la meme page (HP).
    function checkPostRedirect() {
      if (location.search.indexOf('contact_posted=true') === -1) return;
      var formId = location.hash ? location.hash.slice(1) : '';
      var entry = formId && registry[formId];
      if (entry) {
        try { if (window.HexagonTracking) window.HexagonTracking.leadConfirmed(formId); } catch (trackErr) { /* ignore */ }
        showToast({ type: 'success', title: entry.successTitle, text: entry.successText });
        var formEl = document.getElementById(formId);
        var btn = formEl && formEl.querySelector('button[type="submit"]');
        if (btn) {
          btn.disabled = true;
          btn.classList.remove('is-loading');
          btn.classList.add('is-success');
          var label = btn.querySelector('span') || btn;
          label.textContent = 'Email enregistré';
        }
      }
      // Nettoie l'URL (retire ?contact_posted=true + le #id) pour qu'un
      // rechargement/partage ne re-affiche pas le toast a tort.
      var cleanUrl = location.pathname + location.search
        .replace(/[?&]contact_posted=true/, '')
        .replace(/^&/, '?');
      history.replaceState(null, '', cleanUrl);
    }

    // Attention : pour un script "defer", document.readyState vaut deja
    // "interactive" (pas "loading") pendant son execution — un test sur
    // "loading" declenche donc checkPostRedirect() immediatement, AVANT
    // que les scripts de section suivants (home-email-interest.js,
    // configurateur.js, "defer" eux aussi, executes juste apres celui-ci)
    // n'aient rempli le registre via init(). D'ou le test sur "complete"
    // (readyState final, DOMContentLoaded deja passe) plutot que sur
    // "loading" : dans tous les autres cas on attend l'evenement, qui se
    // declenche une fois TOUS les scripts defer executes.
    if (document.readyState === 'complete') {
      checkPostRedirect();
    } else {
      document.addEventListener('DOMContentLoaded', checkPostRedirect);
    }

    window.HexagonContactForm = { init: init, showToast: showToast };
  })();
}
